import React, { useEffect, useState } from 'react'
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom'

import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import { isLoggedIn } from './utils/general'
import SideMenu from 'components/SideMenu/SideMenu'

import NoMatch from './pages/NoMatch'
import Login from './pages/login/Login'
import Home from './pages/home/Home'
import { Administradores, Usuarios } from './pages/Usuarios'
import { Contacto, Escuelas, Inicio, Nosotros, Radio } from './pages/modificaciones'
import { TestComponent } from 'pages/test'
import Noticias from 'pages/noticias/Noticias'
import { Ejes } from 'pages/ejes'
import { InformacionPublica } from 'pages/informacionPublica'
import { Galeria } from 'pages/galeria'
import WikiPlantas from 'pages/wikiPlantas/WikiPlantas'
import Investigacion from 'pages/investigacion/Investigacion'
import PortalInicio from 'pages/modificaciones/PortalInicio'
import PortalNosotros from 'pages/modificaciones/PortalNosotros'

function App() {
	// login state
	const [loggedIn, setLoggedIn] = useState(
		isLoggedIn()
	);

	const [menuExpanded, setMenuExpanded] = useState(true)
	
	if (menuExpanded) {
		document.body.classList.add('menu-expanded')
	} else {
		document.body.classList.remove('menu-expanded')
	}

	useEffect(() => {
		setLoggedIn(isLoggedIn())
	}, []);

	// render
	return (
		<>
			<ToastContainer />
			<Router basename={process.env.PUBLIC_URL}>
					<Route render={({ location, history }) => (
						<>
							<Route exact path="/login" component={props => <Login setLoggedIn={(setLoggedIn)} history={history} />} />
							{loggedIn && <SideMenu location={location} history={history} setLoggedIn={setLoggedIn} menuExpanded={menuExpanded} setMenuExpanded={setMenuExpanded} />}
							<main className={menuExpanded ? 'section expanded' : 'section'}>
								<Switch>
									<Route exact path="/" render={() => {
										return (
											<Redirect to="/inicio" /> 
										)
									}}/>
									<Route exact path="/inicio">
										<Home />
									</Route>
									<Route exact path="/usuarios/administradores">
										<Administradores />
									</Route>
									<Route exact path="/usuarios/clientes">
										<Usuarios />
									</Route>
									<Route exact path="/ejes">
										<Ejes />
									</Route>
									<Route exact path="/informacion-publica">
										<InformacionPublica />
									</Route>
									<Route exact path="/galeria">
										<Galeria />
									</Route>
									<Route exact path="/modificaciones/inicio">
										<Inicio />
									</Route>
									<Route exact path="/modificaciones/nosotros">
										<Nosotros />
									</Route>
									<Route exact path="/modificaciones/escuelas">
										<Escuelas />
									</Route>
									<Route exact path="/modificaciones/radio">
										<Radio />
									</Route>
									<Route exact path="/modificaciones/contacto">
										<Contacto />
									</Route>
									<Route exact path="/modificaciones/portal-inicio">
										<PortalInicio />
									</Route>
									<Route exact path="/modificaciones/portal-nosotros">
										<PortalNosotros />
									</Route>
									<Route exact path="/wiki">
										<WikiPlantas />
									</Route>
									<Route exact path="/investigacion">
										<Investigacion />
									</Route>
									<Route exact path="/noticias">
										<Noticias />
									</Route>
									<Route exact path="/test">
										<TestComponent />
									</Route>
									{loggedIn && <Route path="*" component={props => <NoMatch />} />}
								</Switch>
							</main>
						</>
					)}
					/>
					{!loggedIn && <Redirect to="/login" />}
			</Router>
		</>
	);
}

export default App
